// import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import classnames from "classnames";
import { FromHead, Headline4, Field } from "ellow-web-ui-components-library";
import Button from '../../components/button'
import RadioButton from '../../components/radio';
import Datepicker from '../../components/datepicker';
import Styles from "./styles.module.scss";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RadioGroup from '../../components/radioGroup';
import * as CONSTANTS from '../../utils/CONSTANTS'
import * as Utils from '../../utils/EllowUtils'
import { useEffect, useState } from 'react';
import { putAPI } from "../../api/apis";
import { Error } from "@progress/kendo-react-labels";
import mixpanelData, { userProfile, viewedpageMixpanel } from '../../utils/mixpanel';
import { REACT_APP_CANDIDATE } from '../../utils/common';


export type AvailabilityFormFields = {
  workType: number | string;
  availabilityId: number;
  date: number;
  contractType: number;
  weeks: number;
};

interface Props {
  Back: any,
  loginId: string;
  defaultValues:{workType: string, contractType: string};
}



// const BasicDetails: React.FC<{handleSubmit: () => void}> = (props) => {
const Avilability: React.FC<Props> = ({
  Back,
  loginId,
  defaultValues
}) => {

  useEffect(() => {
    window.scrollTo(0, 0);
    if(defaultValues){
      setWorkType(parseInt(defaultValues.workType))
      setRemoteType(parseInt(defaultValues.contractType))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    viewedpageMixpanel();
  }, []);

  const [disable , setDisable] = useState<boolean>(false)

  const navigation = useNavigate();

  const onSubmitForm = (data: any) => {

    let hasError: boolean = false

    if(!workType){
      errors.workType='Select atleast one option'
      hasError=true
    }

    if(!remoteType){
      errors.remoteType='Select atleast one option'
      hasError=true
    }

    if(!availablitytype){
      errors.availablitytype='Select atleast one option'
      hasError=true
    }

    if (availablitytype === 2 && !date) {
      errors.availablitytype='Select date'
      hasError = true
    }
    if (availablitytype === 3 && !weeks) {
      errors.availablitytype='Select weeks'
      hasError = true
    }
    if (availablitytype === 3 && (weeks > 99 || weeks < 0)) {
      errors.availablitytype='Provide a valid number'
      hasError = true
    }

    if (!hasError) {
      setErros({...errors})
      let values = {
        profileMetadata: {
          workType: workType,
          contractType: remoteType,
          
          availability: {
            availabilityId: availablitytype,
            date: availablitytype === 2 ? date : 0,
            weeks: availablitytype === 3 ? weeks : 0,
            lastUpdateDate: new Date().getTime()
          }

        },
        loginId: loginId,
        candidateStatus: "2",
        action: 'basicProfileSubmit'                         
      }
            
      setDisable(true)
      putAPI(REACT_APP_CANDIDATE + '/candidates', values).then((response) => {
        if ( response ){
          localStorage.setItem("profile_metadata",JSON.stringify(response.data[0].profile_metadata))
          const skills: {name: string, experience: string, expertise: number}[] = response && response.data[0].profile_metadata.techStack && response.data[0].profile_metadata.techStack.map((item: {skill: {skillId: number, skillName: string}, experience: string, expertise: number}) => { return (item.skill.skillName) })
          mixpanelData('MWP-Availability Submit', {
            'distinct_id': response && response.data[0].profile_metadata.email,
            'Phone Number': response && response.data[0].profile_metadata.phoneNumber ,
            'Name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
            'Work Type': values && Utils.checkWorkType(values.profileMetadata.workType),
            'Remote contract Type': values && Utils.checkContractType(values.profileMetadata.contractType),
            'Availability': values && Utils.checkAvailability(values.profileMetadata.availability),
            'Email':response && response.data[0].profile_metadata.email,
          })
          mixpanelData('New MWP - Availability Submit', {
            'distinct_id': response && response.data[0].profile_metadata.email,
            'Candidate loginid':   loginId,
            'Work type': values && Utils.checkWorkType(values.profileMetadata.workType),
            'Remote contract type': values && Utils.checkContractType(values.profileMetadata.contractType),
            'Availability': values && Utils.checkAvailability(values.profileMetadata.availability),
          })
          mixpanelData('MWP-Basic Profile Submitted', {
            'distinct_id': response && response.data[0].profile_metadata.email,
            'Phone Number': response && response.data[0].profile_metadata.phoneNumber ,
            'Name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
            'Work Type': values && Utils.checkWorkType(values.profileMetadata.workType),
            'Skills': skills,
            'workExperience': response && response.data[0].profile_metadata.workExperience,
            'Remote contract Type': values && Utils.checkContractType(values.profileMetadata.contractType),
            'Availability': values && Utils.checkAvailability(values.profileMetadata.availability),
            'Email':response && response.data[0].profile_metadata.email,
          })
          mixpanelData('New MWP - Basic Profile Submitted', {
            'Name': response && (response.data[0].profile_metadata.firstName + ' ' +  response.data[0].profile_metadata.lastName),
            'Email':response && response.data[0].profile_metadata.email,
            'Phone': response && response.data[0].profile_metadata.phoneNumber,
            'distinct_id': response && response.data[0].profile_metadata.email,
            'Candidate loginid': loginId,
            'Core skills': skills,
            'Work experience': `${response && response.data[0].profile_metadata.workExperience} Years`,
            'Availability': values && Utils.checkAvailability(values.profileMetadata.availability),
            'Work type': values && Utils.checkWorkType(values.profileMetadata.workType),
            'Remote contract type': values && Utils.checkContractType(values.profileMetadata.contractType),
            'English proficiency' : response && response.data[0].profile_metadata.englishProficiency.proficiency
          })
          userProfile({
            '$email': response && response.data[0].profile_metadata.email,
            'Work Type': values && Utils.checkWorkType(values.profileMetadata.workType),
            'Contract type': values && Utils.checkContractType(values.profileMetadata.contractType),
            'Availability': values && Utils.checkAvailability(values.profileMetadata.availability),
            'ellow status': 'F1 - Basic profile submitted'
          }, loginId)
          if ( response && response.data[0].provider === 'google'){
            navigation('../dashboard')
          }else {
            navigation('../verification')
          }
        }else{
          setDisable(false)
        }
      })
    }
    setErros({...errors})
  }

  const validationSchema = Yup.object({

  })

  const formOptions = { resolver: yupResolver(validationSchema) }
  const {
    handleSubmit,
  } = useForm<AvailabilityFormFields>(formOptions);

  const [workType, setWorkType] = useState<number>()
  const [availablitytype, setAvailablitytype] = useState<number>()
  const [remoteType, setRemoteType] = useState<number>()
  const [date, setDate] = useState<any>()
  const [weeks, setWeeks] = useState<any>()
  const [errors, setErros] = useState<{ workType?: string, availablitytype?: string, remoteType?: string}>({ workType: "", availablitytype: "", remoteType: "" })


  const workTyeChange = (e: any) => {
    delete errors.workType
    setErros({...errors})
    setWorkType(e.value)

  }

  const remoteTypeChange = (e: any) => {
    setRemoteType(e.value)
    delete errors.remoteType
    setErros({...errors})

  }


  const handleDateChange = (e: any, type: string) => {
    
    delete errors.availablitytype
    if (type === 'date') {
      delete errors.availablitytype
      let newValue = Utils.getMilliSecUTC(e.value)
      setDate(newValue)
    }

    if (type === 'weeks') {
      setWeeks(e.target.value)
      if (e.target.value > 99) {
        errors.availablitytype='Provide a valid number'
      } else {
        delete errors.availablitytype
      }
    }    setErros({...errors})
    setErros({...errors})
  }

  const BackwithoutValidatoion = () => {
    let values = {
      profileMetadata: {
        workType: workType,
        contractType: remoteType,
      },
      loginId: loginId,
      candidateStatus: "1",
    }

    putAPI( REACT_APP_CANDIDATE + `/candidates`, values).then((response) => {
    if(response){
      Back();}
    })
  }

  const defaultValue = new Date();
  
  return (
    <form>
      <Headline4>You are almost there !!!</Headline4>
      <FromHead>How do you want to work with global companies ?</FromHead>
      <div className="form-group mb-40">
        <RadioGroup data={CONSTANTS.WorkType}
          layout="horizontal"
          handleChange={workTyeChange}
          checked={workType}
        />
        <Error>{errors?.workType}</Error>
      </div>
      <FromHead>How soon can you start with us?</FromHead>
      <div className="form-group">
        <RadioButton name="availabilityId" label="Immediately, I’m ready to join any time" value={1} handleChange={(e: any) => { setAvailablitytype(e.value); setDate(0); delete errors.availablitytype }} defaultChecked={false} />
      </div>
      <div className="form-group">
      <div className={classnames(Styles.experienceWrap, Styles.experienceWrapMulti)}>
          <RadioButton name="availabilityId" label="I’m getting relieved from my current job by" value={2} handleChange={(e: any) => { setAvailablitytype(e.value); setDate(''); delete errors.availablitytype }} />
          <div className={Styles.experienceDate}><Datepicker defaultShow={false} min={new Date()} defaultValue={defaultValue} disabled={availablitytype === 2 ? false : true} onChange={(e: any) => handleDateChange(e, 'date')} /></div>
          date
        </div>
        <div className={Styles.experienceWrap}>
          <RadioButton name="availabilityId" label="In" value={3} handleChange={(e: any) => { setAvailablitytype(e.value); setDate(''); delete errors.availablitytype }} />
          <Field
            type='number'
            id="years"
            name="weeks"
            placeholder=""
            size="small"
            maxLength={2}
            disabled={availablitytype === 3 ? false : true}
            onChange={(e: any) => handleDateChange(e, 'weeks')}
          /> weeks after I get the offer
        </div>
      </div>
      <div className="form-group mb-40">
        <RadioButton name="availabilityId" label="Unavailable for Jobs" value={4} handleChange={(e: any) => { setAvailablitytype(e.value); setDate(''); delete errors.availablitytype }} defaultChecked={false} />
      </div>
        
        <Error>{errors?.availablitytype}</Error>

      <FromHead>Are you interested in full time remote work ?</FromHead>

      <div className="form-group">
        <RadioGroup data={CONSTANTS.RemoteType}
          layout="horizontal"
          handleChange={remoteTypeChange}
          checked={remoteType}
        />
        <Error>{errors?.remoteType}</Error>
      </div>
      <div className={Styles.formAction}>
        <Button onClick={handleSubmit(BackwithoutValidatoion)} variant="secondary">Back</Button>
        <Button onClick={handleSubmit(onSubmitForm)} variant="primary" disabled={disable}>Finish</Button>
      </div>
    </form>
  );
}

export default Avilability;